import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import ProfileActions from '../../Search/components/ProfileActions';
import UserPageNew from './UserPageNew';

const Staff = () => {
  return (
    <Grid container sx={{ height: '100%' }}>
      <Grid
        xs={12}
        lg={2.5}
        item
        sx={{
          width: '100vw',
          maxWidth: '100%',
          overflowX: 'hidden',
          borderRight: 0,
          borderColor: 'divider',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          p: 1.5,
          pb: 0,
          gap: 1,
          margin: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          WebkitOverflowScrolling: 'touch',
        }}
        container
      >
        <ProfileActions staff={true} />
        <Box height={50} display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold', color: '#004BAE' }}>Enjoy Your Delights</Typography>
        </Box>
        <Stack
          sx={{
            height: `calc(100vh - ${'135px'})`,
            width: '100%',
            maxWidth: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          <UserPageNew event={false} />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Staff;
